import { Country } from './Country';
export const BaseApiVersion = 'v1';
export const BaseApiUrl = `/api/${BaseApiVersion}`;
export const LoginApiUrl = (subroot) => `${BaseApiUrl}/${subroot ? `${subroot}/login` : 'login'}`;
export const StorageGridPath = `grid`;
export const objects = {
    block: 'block',
    blocks: 'blocks',
    dashboard: 'dashboard',
    dashboards: 'dashboards',
    settings: 'settings',
    debugSettings: 'debugsettings',
};
export const StorageBlocksPath = (dashboardId) => `${objects.blocks}/${dashboardId}`;
export const StorageBlockPath = (blockId) => `${objects.block}/${blockId}`;
export const StorageBlockSettingsPath = (blockId) => `${objects.block}/${blockId}/${objects.settings}`;
export const StorageSettingsBlockPath = `${objects.settings}/block`;
export const StorageSettingsFieldPath = (field) => `${objects.settings}/${field}`;
export const StorageSettingsBlockTypeFieldPath = (type) => StorageSettingsFieldPath(`${objects.block}-${type}`);
export const StorageDashboardsPath = `${objects.dashboards}`;
export const StorageDashboardPath = `${objects.dashboard}`;
export const CreateDashboardPath = `${objects.dashboard}/new`;
export const DefaultDashboardPath = `${objects.dashboard}/defaults`;
export const DeleteDashboardPath = (dashboardId) => `${objects.dashboard}/${dashboardId}`;
export const StorageFavoritesPath = `favorites`;
export const RefreshTokenPath = `/refresh_token`;
export const DashboardSettingsPath = `${objects.settings}/dashboard`;
export const PendingApplicationsPath = '/db/applications';
export const StorageStrategyPath = `resource/strategy`;
export const MAX_TRANSFER_AMOUNT = 50000;
// accepted countries of residence for accts
export const AcceptedCountries = [
    Country.Australia,
    Country.NewZealand,
    Country.UnitedKingdomOfGreatBritainAndNorthernIreland,
    Country.UnitedStatesOfAmerica,
];
export const ApexAcceptedCountries = [
    Country.Australia,
    Country.UnitedKingdomOfGreatBritainAndNorthernIreland,
    Country.UnitedStatesOfAmerica,
    Country.NewZealand,
];
export const RQDAcceptedCountries = [
    Country.Argentina,
    Country.Chile,
    Country.Peru,
    Country.UnitedStatesOfAmerica,
    Country.Uruguay,
];
export const ClientVersionHeader = 'x-client-version';
export const PERSIST_BLOCKS_DEBOUNCE_MS = 1000;
//# sourceMappingURL=constants.js.map